var colors = {
  white100: '#ffffff',
  black100: '#000000',
  grey900: '#22201F',
  grey800: '#434140',
  grey700: '#62605F',
  grey600: '#767473',
  grey500: '#9F9D9C',
  grey400: '#BEBCBB',
  grey300: '#E1DFDE',
  grey200: '#EFEDEC',
  grey100: '#F6F4F3',
  grey50: '#FCFAF8',
  red900: '#BD0000',
  red800: '#CB0008',
  red700: '#D70012',
  red600: '#E90017',
  red500: '#F71414',
  red400: '#F43738',
  red300: '#EB6261',
  red200: '#F4908D',
  red100: '#FFC7CC',
  red50: '#FFE9EC',
  yellow900: '#FF7300',
  yellow800: '#FF9300',
  yellow700: '#FFA400',
  yellow600: '#FFB500',
  yellow500: '#FFC509',
  yellow400: '#FFCD29',
  yellow300: '#FED850',
  yellow200: '#FEE283',
  yellow100: '#FEEDB4',
  yellow50: '#FFF9E1',
  blue900: '#163FB9',
  blue800: '#0D60D9',
  blue700: '#0071EB',
  blue600: '#0084FF',
  blue500: '#0093FF',
  blue400: '#25A3FF',
  blue300: '#56B4FF',
  blue200: '#8BC9FF',
  blue100: '#B9DEFF',
  blue50: '#E2F2FF',
  green900: '#0C5130',
  green800: '#196F45',
  green700: '#1D8050',
  green600: '#24925D',
  green500: '#2AA067',
  green400: '#4EAE7D',
  green300: '#6EBC92',
  green200: '#98CEB0',
  green100: '#C0E1CE',
  green50: '#E5F3EB',
  purple900: '#780072',
  purple800: '#93007D',
  purple700: '#A20083',
  purple600: '#B40089',
  purple500: '#C1008D',
  purple400: '#CD329D',
  purple300: '#D85DAD',
  purple200: '#E58EC4',
  purple100: '#F0BCDB',
  purple50: '#F9E4F0'
};
export default colors;
//# sourceMappingURL=colors.js.map